// File upload
export const FILE_UPLOAD_LOAD_FILES = 'FILE_UPLOAD_LOAD_FILES';
export const FILE_UPLOAD_ADD_FILE = 'FILE_UPLOAD_ADD_FILE';
export const FILE_UPLOAD_REMOVE_FILE = 'FILE_UPLOAD_REMOVE_FILE';
export const FILE_UPLOAD_CLEAR_FILES = 'FILE_UPLOAD_CLEAR_FILES';
export const FILE_UPLOAD_ADD_UPLOADED_FILE = 'FILE_UPLOAD_ADD_UPLOADED_FILE';
export const FILE_UPLOAD_FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_FILE_UPLOAD_SUCCESS';
export const FILE_UPLOAD_FILE_UPLOAD_FAILED = 'FILE_UPLOAD_FILE_UPLOAD_FAILED';
export const FILE_UPLOAD_FILE_UPLOAD_PROGRESS = 'FILE_UPLOAD_FILE_UPLOAD_PROGRESS';
export const FILE_UPLOAD_READ_FILE_SUCCESS = 'FILE_UPLOAD_READ_FILE_SUCCESS';
export const FILE_UPLOAD_FILE_PERSIST_SUCCESS = 'FILE_UPLOAD_FILE_PERSIST_SUCCESS';
export const FILE_UPLOAD_FILE_PERSIST_FAILED = 'FILE_UPLOAD_FILE_PERSIST_FAILED';
export const FILE_UPLOAD_EXTEND_SESSION = 'FILE_UPLOAD_EXTEND_SESSION';

// Image gallery
export const SHOW_IMAGE_GALLERY = 'SHOW_IMAGE_GALLERY';
export const CLOSE_IMAGE_GALLERY = 'CLOSE_IMAGE_GALLERY';
export const CLOSE_IMAGE_GALLERY_SUCCESS = 'CLOSE_IMAGE_GALLER_SUCCESS';
export const SET_CURRENT_IMAGE_INDEX = 'SET_CURRENT_IMAGE_INDEX';
export const SHOW_CHILDREN_TO_TAG = 'SHOW_CHILDREN_TO_TAG';
export const LIKE_IMAGE = 'LIKE_IMAGE';
export const LIKE_IMAGE_SUCCESS = 'LIKE_IMAGE_SUCCESS';
export const LIKE_IMAGE_FAILED = 'LIKE_IMAGE_FAILED';
export const UNLIKE_IMAGE = 'UNLIKE_IMAGE';
export const UNLIKE_IMAGE_SUCCESS = 'UNLIKE_IMAGE_SUCCESS';
export const UNLIKE_IMAGE_FAILED = 'UNLIKE_IMAGE_FAILED';
export const TAG_IMAGE = 'TAG_IMAGE';
export const TAG_IMAGE_SUCCESS = 'TAG_IMAGE_SUCCESS';
export const TAG_IMAGE_FAILED = 'TAG_IMAGE_FAILED';
export const REMOVE_IMAGE_TAG = 'REMOVE_IMAGE_TAG';
export const REMOVE_IMAGE_TAG_SUCCESS = 'REMOVE_IMAGE_TAG_SUCCESS';
export const REMOVE_IMAGE_TAG_FAILED = 'REMOVE_IMAGE_TAG_FAILED';

// Profile > Child Profile
export const UPDATING_CHILD_PERMISSIONS = 'UPDATING_CHILD_PERMISSIONS';
export const SHOW_CHILD_PERMISSIONS = 'SHOW_CHILD_PERMISSIONS';

// Profile > Child Profile > Permission List
export const UPDATE_PERMISSION = 'UPDATE_PERMISSION';
export const UPDATE_PERMISSION_SUCCESS = 'UPDATE_PERMISSION_SUCCESS';
export const UPDATE_PERMISSION_ERROR = 'UPDATE_PERMISSION_ERROR';
export const CHILD_PERMISSION_FETCH = 'CHILD_PERMISSION_FETCH';
export const CHILD_PERMISSION_FETCH_SUCCESS = 'CHILD_PERMISSION_FETCH_SUCCESS';
export const CHILD_PERMISSION_FETCH_ERROR = 'CHILD_PERMISSION_FETCH_ERROR';
export const EDIT_PERMISSION_REPLY = 'EDIT_PERMISSION_REPLY';
export const TOGGLE_PERMISSION_DETAILS = 'TOGGLE_PERMISSION_DETAILS';

// Session
export const DID_RECEIVE_ACCESS_TOKEN = 'DID_RECEIVE_ACCESS_TOKEN';
export const FETCH_ACCOUNT_SUCCESS = 'FETCH_ACCOUNT_SUCCESS';
